import { useState } from 'preact/hooks';

import NavigationTabs from '@shared/components/navigation/navigation-tabs';
import NavTab from '@shared/components/navigation/navigation-tabs/nav-tab';
import { html, nothing } from '@shared/utils/rendering/html';

import { AdminTabsConfig } from '@core/configs/navigation/admin/admin-tabs.config';
import { AdminTabs } from '@core/constants/routing/admin/admin-tabs.constants';

import AdminUsers from './users';
import AdminSystems from './systems';
import AppLayout from '../app-layout';

import withRoleGuard from '@core/utils/routing/with-role-guard';
import withAuthGuard from '@core/utils/routing/with-auth-guard';

import { AdminContextProvider } from './context/admin.context';
import { Roles } from '@core/constants/security/roles.constants';
import { useAuth } from '@core/utils/context/auth-context';

const Admin = ({ path, id, activePage }) => {
    const [activeTab, setActiveTab] = useState(activePage ?? AdminTabsConfig[0]);

    const { isInRole } = useAuth();

    const GuardedSystemsPage = withAuthGuard(
        withRoleGuard(AdminSystems, { required: [Roles.Developer] })
    );

    const GuardedUsersPage = withAuthGuard(
        withRoleGuard(AdminUsers, { required: [Roles.Admin, Roles.Developer] })
    );

    return html`
    <${AppLayout}>
        <h1 class="title">Admin</h1>

        <${NavigationTabs}>
            ${AdminTabsConfig.filter((tab) => isInRole(tab.requiredRoles)).map(
                (tab) =>
                    html`<${NavTab}
                        activeTab=${activeTab}
                        setActiveTab=${setActiveTab}
                        tabDetails=${tab}
                    />`
            )}
        </${NavigationTabs}>

        <${AdminContextProvider}>
            ${
                activeTab.id == AdminTabs.users
                    ? html`<${GuardedUsersPage} userId=${id} />`
                    : nothing
            }
            ${
                activeTab.id == AdminTabs.systems
                    ? html`<${GuardedSystemsPage} systemId=${id} />`
                    : nothing
            }
        </${AdminContextProvider}>

    </${AppLayout}>
    `;
};

export default Admin;
